import { PushPin, PushPinOutlined } from '@mui/icons-material';
import { Menu, MenuItem, styled } from '@mui/material';
import React from 'react';

import { usePinPrompt } from '../../hooks/usePinPrompt';
import { IconLabel } from '../../theme/CustomComponents';
import { Prompt } from '../../Types/prompt';

interface PromptPinOptionsMenuProps {
  prompt: Prompt;
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  isAIAppStore: boolean;
}

const StyledIconLabel = styled(IconLabel)({
  fontSize: '12px',
});

const StyledIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
});

const PromptPinOptionsMenu = ({
  prompt,
  anchorEl,
  open,
  onClose,
  isAIAppStore,
}: PromptPinOptionsMenuProps) => {
  const { handleUserPin, handleFolderPin } = usePinPrompt({ redirectOnPin: !isAIAppStore });
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      MenuListProps={{ dense: true }}
      onClick={(e) => e.stopPropagation()}
    >
      <MenuItem
        onClick={() => {
          onClose();
          handleFolderPin(prompt);
        }}
      >
        <StyledIconLabel>
          <StyledIcon>
            {prompt.folderPinned ? (
              <PushPin sx={{ color: '#0047FF', fontSize: 16 }} />
            ) : (
              <PushPinOutlined sx={{ color: '#0047FF', fontSize: 16 }} />
            )}
          </StyledIcon>
          {prompt.folderPinned ? 'Unpin from Folder' : 'Pin to Folder'}
        </StyledIconLabel>
      </MenuItem>

      <MenuItem onClick={() => handleUserPin(prompt, prompt.pinned || false)}>
        <StyledIconLabel>
          <StyledIcon>
            {prompt.pinned ? (
              <PushPin sx={{ color: '#0B6E27', fontSize: 16 }} />
            ) : (
              <PushPinOutlined sx={{ color: '#0B6E27', fontSize: 16 }} />
            )}
          </StyledIcon>
          {prompt.pinned ? 'Unpin for Me' : 'Pin for Me'}
        </StyledIconLabel>
      </MenuItem>
    </Menu>
  );
};

export default PromptPinOptionsMenu;
